






















































































































































































import { homeworkData, homeworkList, homeworkDel } from "@/api/homework";
import { Component, Vue, Mixins } from "vue-property-decorator";
import {
  staffList,
  geteacherList,
  getSelectClassList,
  getSelectCourseList,
  autoSearchData,
  searchStudent,
} from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
import { mixin } from "@/mixin/tabPageInfoMixin";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "afterClass",
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  tableData = [];
  jobList = [];
  searchInfo: any = {
    staff_id: "" as number | string,
    staff_list: [],
    expireTimeClass: [],
    type: -1,
  };
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 0;
  page: number = 1;
  staffName: any = ""; //员工搜索名字
  teacherName = ""; //教师搜索名字
  className: any = ""; //班级搜索类型
  courseName = "";
  studentList: any[] = []; // 学员列表
  homework_ids = [];
  showFormSearch = false;
  selectNum: number = 0;
  created() {
    this.mixinGetPageInfo("afterClassExercises");
    if (this.$route.query.t_s_id) {
      this.searchInfo.staff_id = Number(this.$route.query.t_s_id);
    }
    // 来自教师学员关联关系页面
    if (this.$route.query.tid) {
      this.searchInfo.staff_id = Number(this.$route.query.tid);
    }
    if (
      this.$route.query.name === "week" ||
      this.$route.query.name === "month"
    ) {
      this.searchInfo.expireTimeClass[0] = new Date(this.$route.query.s_time);
      this.searchInfo.expireTimeClass[1] = new Date(this.$route.query.e_time);
      this.datechooseClass(this.searchInfo.expireTimeClass);
    }
    this.getList(
      {
        page: this.page,
        page_size: this.pageSize,
      },
      () => {}
    );
    this.globalSearch(
      this.searchInfo.className ? this.searchInfo.className : "",
      "class"
    );
    this.globalSearch(
      this.searchInfo.studentName ? this.searchInfo.studentName : "",
      "student"
    );
  }
  resetSearch() {
    this.searchInfo = {
      staff_id: "" as number | string,
      expireTimeClass: [],
      type: -1,
    };
    this.page = 1;
    this.pageSize = 10;
    this.getList(
      {
        page: this.page,
        page_size: this.pageSize,
      },
      () => {}
    );
  }
  clickDetail(e: { homework_id: number }) {
    const _t = this as any;
    _t.mixinSavePageInfo("afterClassExercises");
    _t.$router.push({ name: "afterDetails", query: { id: e.homework_id } });
  }
  delAll() {
    const _t = this as any;
    if (_t.homework_ids.length == 0) {
      _t.$message({
        type: "error",
        message: "请选择要删除的练习",
      });
      return;
    }
    _t.$confirm(
      "删除后学员提交的练习也会一起删除，且数据无法恢复，确定要删除吗？",
      `批量删除 - 共选中 ${this.selectNum} 个练习`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        _t.delHomework(_t.homework_ids);
      })
      .catch(() => {});
  }
  addHomeWork() {
    const _t = this as any;
    _t.$router.push({ name: "addAfter" });
  }
  chooseItem(e: any) {
    if (e) {
      this.selectNum = e.length;
    }
    const _t = this;
    const homework_id: any = [];
    e.map((a: any) => {
      homework_id.push(a.homework_id);
    });
    _t.homework_ids = homework_id;
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList(
      {
        page: this.page,
        page_size: this.pageSize,
      },
      () => {}
    );
  }
  handleDelete(e: any) {
    const _t = this;
    const homework_id: any = [];
    homework_id.push(e.homework_id);
    _t.$confirm(
      "删除后学员提交的练习也会一起删除，且数据无法恢复，确定要删除吗？",
      `删除 - ${e.title}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        _t.delHomework(homework_id);
      })
      .catch(() => {});
  }
  delHomework(homework_id: any) {
    const _t = this;
    homeworkDel({ homework_ids: homework_id }).then((res: any) => {
      if (res.error_code == 0) {
        this.getList(
          {
            page: 1,
            page_size: _t.pageSize,
          },
          () => {}
        );
        _t.$message({
          type: "success",
          message: "删除成功",
        });
      }
    });
  }
  // 通用搜索框
  getSelectrList(e: string) {
    const _t = this as any;
    _t.globalSearch("", e);
  }
  getglobalsearchdata(data: autoSearchData, type: String) {
    if (type == "staff") {
      return staffList(data as any);
    } else if (type == "teacher") {
      return geteacherList(data);
    } else if (type == "class") {
      return getSelectClassList(data);
    } else if (type == "course") {
      return getSelectCourseList(data);
    } else if (type == "student") {
      return searchStudent(data);
    }
  }
  async globalSearch(queryString: string, type: string) {
    const _t = this;
    let data: autoSearchData = {
      page: 1,
      page_size: 100,
    };
    let restaurants: any = {};
    if (queryString) {
      data = {
        page: 1,
        page_size: 10,
      };
      if (type == "class") {
        this.searchInfo.className = queryString;
        data.name = queryString;
      } else if (type == "course") {
        data.title = queryString;
      } else if (type === "student") {
        data.key_word = queryString;
        this.searchInfo.studentName = queryString;
      } else {
        data.key_word = queryString;
        this.searchInfo.staffName = queryString;
      }
    }
    restaurants = await _t.getglobalsearchdata(data, type);
    const list = restaurants.data.list;
    if (type == "staff") {
      _t.staffName = list;
    } else if (type == "teacher") {
      _t.teacherName = list;
    } else if (type == "class") {
      _t.className = list;
    } else if (type == "course") {
      _t.courseName = list;
    } else if (type === "student") {
      _t.studentList = list;
    }
    _t.mixinSavePageInfo("afterClassExercises");
  }
  // 通用搜索框结束
  datechooseClass(e: { 0: string; 1: string }) {
    const _t = this as any;
    let expire_start_time: number | String = "";
    let expire_end_time: number | String = "";
    // if (e != null) {
    if (e) {
      expire_start_time = e[0];
      expire_end_time = e[1];
    }
    _t.searchInfo.start_time = Number(expire_start_time) / 1000;
    _t.searchInfo.end_time = Number(expire_end_time) / 1000;
    _t.searchInfo.end_time = _t.searchInfo.end_time + 3600 * 24 - 1;
    _t.handleSearch();
  }
  getList(data: homeworkData, cb: Function) {
    const _t = this as any;
    if (_t.searchInfo.title != "") {
      data.title = _t.searchInfo.title;
    }
    if (_t.searchInfo.staff_id != "") {
      data.staff_ids = _t.searchInfo.staff_id;
    }
    if (_t.searchInfo.class_id != "") {
      data.class_id = _t.searchInfo.class_id;
    }
    if (_t.searchInfo.start_time != "") {
      data.start_time = _t.searchInfo.start_time;
    }
    if (_t.searchInfo.end_time != "") {
      data.end_time = _t.searchInfo.end_time;
    }
    if (_t.searchInfo.student_id != "") {
      data.student_id = _t.searchInfo.student_id;
    }
    if (_t.searchInfo.type > -1) {
      data.type = _t.searchInfo.type;
    }
    if (_t.searchInfo.sort_type) {
      data.sort_type = _t.searchInfo.sort_type;
    }
    if (_t.searchInfo.sort_field) {
      data.sort_field = _t.searchInfo.sort_field;
    }
    homeworkList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            a.publish_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.publish_time + "000"))
            );
            a.deadline_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.deadline_time + "000"))
            );
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
        if (cb) {
          cb();
        }
      }
    });
  }
  handlePagerChange(e: number) {
    this.mixinSavePageInfo("afterClassExercises");
    this.getList(
      {
        page: e,
        page_size: this.pageSize,
      },
      () => {}
    );
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList(
      {
        page: 1,
        page_size: e,
      },
      () => {}
    );
    this.mixinSavePageInfo("afterClassExercises");
  }
  handleSearch(type: string, v: any) {
    if (type === "staff") {
      this.staffName.map((item: any) => {
        if (item.staff_id === v) {
          this.searchInfo.staffName = item.name;
        }
      });
    } else if (type === "class") {
      this.className.map((item: any) => {
        if (item.class_id === v) {
          this.searchInfo.className = item.name;
        }
      });
    } else if (type === "student") {
      this.studentList.map((item: any) => {
        if (item.student_id === v) {
          this.searchInfo.studentName = item.name;
        }
      });
    }
    const _t = this as any;
    _t.getList(
      {
        page: 1,
        page_size: _t.pageSize,
      },
      () => {}
    );
  }
}
